/*
 * @Description: 实时定位驾驶舱 — 告警铃铛
 *   铃铛 + 未读数角标（D5）；点击打开「告警记录」弹窗，打开即标记全部已读。
 *   自包含：自取 groupId，角标走 useAlertBell，列表由 AlertRecordModal 自行加载。
 */
import React, { useState } from 'react'
import { useGroupID } from '../../../../app/hooks'
import { useAlertBell } from '../../hooks/useAlertBell'
import AlertRecordModal from '../AlertRecordModal'
import './index.scss'

/** 告警铃铛图标（设计稿 Group.svg） */
const BellIcon: React.FC = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path
      d="M13.5996 6.1001C13.5996 4.77402 13.0728 3.50225 12.1351 2.56456C11.1975 1.62688 9.92569 1.1001 8.59961 1.1001C7.27353 1.1001 6.00176 1.62688 5.06408 2.56456C4.12639 3.50225 3.59961 4.77402 3.59961 6.1001C3.59961 12.1001 1.09961 13.6001 1.09961 13.6001H16.0996C16.0996 13.6001 13.5996 12.1001 13.5996 6.1001Z"
      stroke="#374151"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0996 16.6001C9.95461 16.872 9.73846 17.0993 9.47425 17.2578C9.21005 17.4164 8.90772 17.5001 8.59961 17.5001C8.29149 17.5001 7.98917 17.4164 7.72497 17.2578C7.46076 17.0993 7.2446 16.872 7.09961 16.6001"
      stroke="#374151"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const AlertBell: React.FC = () => {
  const groupId = useGroupID()
  const { unreadCount, markAllRead } = useAlertBell(groupId)
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
    // 打开告警记录即标记全部已读、角标清零
    markAllRead()
  }

  return (
    <>
      <button
        type="button"
        className="cockpit-alert-btn"
        onClick={handleOpen}
        title="告警记录"
      >
        <BellIcon />
        {unreadCount > 0 && (
          <span className="cockpit-alert-btn__badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>
      <AlertRecordModal
        visible={open}
        groupId={groupId}
        onClose={() => setOpen(false)}
      />
    </>
  )
}

export default AlertBell
